import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewZealandFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0003 0.000488281V10.0001H10.0001V30.0002H5.16119e-09C-0.000110031 35.9337 1.75926 41.734 5.05562 46.6676C8.35199 51.6012 13.0373 55.4465 18.5191 57.7172C24.0008 59.988 30.0328 60.5822 35.8523 59.4247C41.6717 58.2672 47.0173 55.41 51.2129 51.2145C55.4086 47.0189 58.2659 41.6734 59.4235 35.8539C60.5811 30.0344 59.9871 24.0023 57.7165 18.5205C55.446 13.0386 51.6008 8.35315 46.6674 5.05662C41.7339 1.76009 35.9337 0.000542927 30.0003 0.000488281V0.000488281Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9998 6.00049C8.27138 8.79242 5.2454 12.4154 3.16231 16.5816C1.07923 20.7478 -0.00354553 25.3424 8.72194e-06 30.0004H11.9998V6.00049Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99991 12.0004H30.0004V0.000497952C25.3423 -0.00324482 20.7476 1.07945 16.5813 3.16257C12.4149 5.24568 8.79186 8.27178 5.99991 12.0004Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.83096 9.78908L24.0001 30H30.0001V22.5002L15.1498 3.93799C12.4198 5.49445 9.95029 7.46872 7.83096 9.78908Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0003 3H16.9119C10.8481 5.94919 5.94935 10.848 3.0003 16.912V29.9999H9.00008V9.00009H30.0003V3Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0004 25.0596L16.9999 9.00049H10.9999L28.0002 30.0006H30.0004V25.0596Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.1339 30.0005L36.1436 27.0745L33.4232 25.1606H36.8158L37.7919 22.3447L38.7959 25.1606H42.1734L39.4537 27.0745L40.4616 30.0005L37.7979 28.2047L35.1339 30.0005Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.798 27.5214L39.3929 28.5959L38.7892 26.8492L40.375 25.7331H38.41L37.798 24.0171L37.2027 25.7331H35.2214L36.8079 26.8492L36.205 28.5959L37.798 27.5214Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.6336 30.0005L53.6437 27.0745L50.9229 25.1606H54.3155L55.2916 22.3447L56.2957 25.1606H59.6739L56.9535 27.0745L57.9613 30.0005L55.298 28.2047L52.6336 30.0005Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.2981 27.5214L56.8926 28.5959L56.289 26.8492L57.8748 25.7331H55.9093L55.2981 24.0171L54.7032 25.7331H52.7211L54.3077 26.8492L53.7047 28.5959L55.2981 27.5214Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.8843 19.6563L44.8944 16.7307L42.1732 14.8167H45.5662L46.5411 12.0005L47.5448 14.8167H50.9231L48.2026 16.7307L49.212 19.6563L46.5476 17.8604L43.8843 19.6563Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.5476 17.1784L48.1432 18.2521L47.5388 16.5055L49.1246 15.3897H47.1599L46.5476 13.6733L45.953 15.3897H43.9709L45.5579 16.5055L44.955 18.2521L46.5476 17.1784Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.0468 46.6562L44.3734 42.8101L40.798 40.2944H45.2571L46.5382 36.5933L47.8572 40.2944H52.2971L48.7239 42.8101L50.0482 46.6562L46.5473 44.2952L43.0468 46.6562Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.5474 43.3984L48.643 44.8116L47.8516 42.5142L49.9358 41.0473H47.3516L46.5474 38.7935L45.7658 41.0473H43.1597L45.2454 42.5142L44.4537 44.8116L46.5474 43.3984Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7512 9.00049H10.563V12.0005H22.7512V9.00049Z",
			fill: "white"
		})
	]
});
export default SvgNewZealandFlag;
